import { IChartData } from './chartData';

export const BAR_CHART_TEMPLATE_DATA: IChartData = {
	title: 'Chart title',
	hide_title: true,
	x_title: 'X Title',
	y_title: 'Y Title',
	categories: new Array(100)
		.fill('')
		.map((element: '', index: number) => 'Shop' + (index + 1)),
	values: new Array(100)
		.fill('')
		.map(() => Math.floor(Math.random() * 1000) + 1),
	prev_values: new Array(100)
		.fill('')
		.map(() => Math.floor(Math.random() * 1000) + 1)
}